/**
 * Transcription Language Options
 *
 * The workflow accepts an optional `language` input as an ISO 639-1 code.
 * An empty string ("") tells the transcription model to auto-detect.
 * Only the code is sent over the wire; the label is cosmetic.
 */

export interface LanguageOption {
  /** ISO 639-1 code sent to the workflow; "" means auto-detect. */
  value: string;
  label: string;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: '', label: 'Auto-detect' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'zh', label: 'Mandarin' },
];

/** Default selection: auto-detect (empty language code). */
export const DEFAULT_LANGUAGE = '';
